var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-container"},[_c('ul',{staticClass:"list-wrapper"},_vm._l((_vm.categories),function(category,i){return _c('li',{key:i,staticClass:"element",class:i===_vm.active? 'active' : '',on:{"click":function($event){return _vm.$emit('changeCat', i)}}},[_vm._v(" "+_vm._s(category)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }